import type { ReactNode } from 'react';
import { Button, makeStyles, tokens } from '@fluentui/react-components';
import {
  AlertUrgent20Regular,
  Camera20Regular,
  ClipboardTaskListLtr20Regular,
  DocumentCheckmark20Regular,
} from '@fluentui/react-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import TitledCard from '../Layout/TitledCard';
import type { AttentionKind, HomeAttentionItem } from './homeTypes';
import { useHomeListStyles } from './useHomeListStyles';

const useStyles = makeStyles({
  icon: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '36px',
    height: '36px',
    flexShrink: 0,
    borderRadius: tokens.borderRadiusMedium,
    backgroundColor: tokens.colorBrandBackground2,
    color: tokens.colorBrandForeground1,
  },
});

const ICONS: Record<AttentionKind, ReactNode> = {
  'form-review': <ClipboardTaskListLtr20Regular />,
  'report-ready': <DocumentCheckmark20Regular />,
  'photos-missing': <Camera20Regular />,
};

const AttentionList = ({ items }: { items: HomeAttentionItem[] }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const styles = useStyles();
  const list = useHomeListStyles();
  return (
    <TitledCard
      title={t('needsYourAttention', 'Needs your attention')}
      icon={<AlertUrgent20Regular />}
    >
      <ul className={list.list}>
        {items.map((item) => (
          <li key={item.id} className={list.row}>
            <span className={styles.icon}>{ICONS[item.kind]}</span>
            <div className={list.text}>
              <span className={list.primary}>{item.title}</span>
              <span className={list.secondary}>{item.detail}</span>
            </div>
            <Button size="small" onClick={() => navigate(item.href)}>
              {item.actionLabel}
            </Button>
          </li>
        ))}
      </ul>
    </TitledCard>
  );
};

export default AttentionList;
